import {educatAPI, RestQueryParams} from 'educat-common-web';
import {Observable} from 'rxjs';

export function getInquiryAPI(inquiryId: string, secret: string): Observable<any> {
    const headers = {
        'X-Inquiry-Secret': secret
    };

    return educatAPI.get(`inquiries/${inquiryId}`, new RestQueryParams(), headers);
}